import { render, staticRenderFns } from "./QrcodeGenerator.vue?vue&type=template&id=70bcc547&scoped=true"
import script from "./QrcodeGenerator.vue?vue&type=script&lang=js"
export * from "./QrcodeGenerator.vue?vue&type=script&lang=js"
import style0 from "./QrcodeGenerator.vue?vue&type=style&index=0&id=70bcc547&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70bcc547",
  null
  
)

export default component.exports